import withList from '../../with-list/main';
import { selectors, actions } from './';
import table from './table-initial-data';

export default withList(selectors, actions, table, {
	link: '/blog/articles/editor',
	text: 'Create article'
});


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/blog/article/list/main.js